<template>
  <div id="app-center">
    <my-head></my-head>
    <center-head></center-head>
    <div class="center-box">
      <div class="center-list">
        <el-row :gutter="30">
          <el-col :span="4">
            <left-menu></left-menu>
          </el-col>
          <el-col :span="20">
            <div class="center-left">
              <el-card>
                <el-input
                  v-model="search.project_name"
                  :clearable="true"
                  placeholder="请输入项目名称"
                  size="small"
                  style="width: 200px"
                ></el-input>

                <el-button
                  type="primary"
                  size="small"
                  icon="el-icon-search"
                  @click="$refs.tables.handleSearch()"
                  >搜索</el-button
                >
              </el-card>

              <WtDataTable
                ref="tables"
                :search="search"
                :listUrl="$db.config.com_project.launch.list"
                :urlParams="{ type: 1 }"
                :delUrl="$db.config.com_project.launch.delete"
              >
                <div slot="buttons">
                  <el-button
                    size="small"
                    style="margin: 10px 0px"
                    icon="el-icon-plus"
                    type="primary"
                    @click="doLaunch"
                    >发起项目</el-button
                  >
                </div>
                <template slot="columns">
                  <el-table-column
                    prop="project_name"
                    label="项目名称"
                    align="center"
                    min-width="250"
                  >
                    <template slot-scope="scope">
                      <a href="javascript:;" @click="showDetail(scope.row)">{{
                        scope.row.project_name
                      }}</a>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="type_text"
                    label="项目类型"
                    align="center"
                    width="120"
                  ></el-table-column>
                  <!-- <el-table-column prop="cat_id_text" label="合作体系" align="center" width="120"></el-table-column> -->
                  <el-table-column
                    prop="description"
                    label="描述"
                    align="center"
                    min-width="150"
                    show-overflow-tooltip
                  ></el-table-column>
                  <el-table-column
                    prop="regdate_start"
                    label="发起时间"
                    align="center"
                    width="120"
                  ></el-table-column>
                  <el-table-column
                    prop="status_text"
                    label="状态"
                    width="100"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span
                        v-if="scope.row.status == 2"
                        style="
                          color: red;
                          text-decoration: underline;
                          cursor: pointer;
                        "
                      >
                        <el-popover
                          placement="top"
                          title="审核意见："
                          width="200"
                          trigger="click"
                          :content="scope.row.audit_opinion"
                        >
                          <span slot="reference">{{
                            scope.row.status_text
                          }}</span>
                        </el-popover>
                      </span>
                      <span v-else>{{ scope.row.status_text }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    label="操作"
                    align="center"
                    width="200"
                    fixed="right"
                  >
                    <template slot-scope="scope">
                      <el-button-group>
                        <template v-if="scope.row.if_option">
                          <el-button
                            type="primary"
                            icon="el-icon-edit"
                            @click="doEdit(scope.row)"
                            size="mini"
                            >编辑</el-button
                          >
                          <el-button
                            type="danger"
                            icon="el-icon-delete"
                            @click="doDelete(scope.row)"
                            size="mini"
                            >删除</el-button
                          >
                        </template>
                      </el-button-group>
                    </template>
                  </el-table-column>
                </template>
              </WtDataTable>
            </div>
          </el-col>
        </el-row>
      </div>
      <info
        v-if="if_open"
        v-model="if_open"
        :title="info_title"
        :id="project_id"
        :look="if_look"
        @success="success"
      ></info>

      <foot-div></foot-div>
    </div>
  </div>
</template>
<script>
import myHead from "../../public/head";
import centerHead from "../../public/center_head";
import leftMenu from "../../public/menu";
import footDiv from "../../public/foot";
import info from "./info";
export default {
  components: {
    myHead,
    centerHead,
    leftMenu,
    footDiv,
    info,
  },
  data() {
    return {
      search: { project_name: null },
      if_look: false,
      project_id: null,

      if_open: false,
      info_title: "",
    };
  },
  methods: {
    showDetail(row) {
      this.if_look = true;
      this.info_title = "查看项目信息";
      this.project_id = row.id;
      this.if_open = true;
    },
    //发起项目
    doLaunch() {
      this.info_title = "发起省区项目信息";
      this.project_id = null;
      this.if_look = false;
      this.if_open = true;
    },

    //编辑操作
    doEdit(row) {
      this.info_title = "修改省区项目信息";
      this.project_id = row.id;
      this.if_look = false;
      this.if_open = true;
    },

    //删除操作
    doDelete(row) {
      this.$refs.tables.doDelete(row.id);
    },

    success() {
      if (this.project_id > 0) {
        this.$refs.tables.reloadData();
      } else {
        this.$refs.tables.reloadTable();
      }
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
#app-center {
  width: 100%;
  // height: 100%;
  background-color: #f1f1f1;
}

.center-box {
  .center-list {
    margin: 0 auto;
    width: 98%;
    padding-top: 20px;

    .center-left {
      background-color: #fff;
      border-top: 2px solid #b60205;
      padding-top: 30px;
      overflow: hidden;
      > ul {
        padding: 0 30px;

        > li {
          list-style: none;
          font-size: 1vw;
          color: #666;
          margin-bottom: 40px;
          cursor: pointer;
        }
        > li.active {
          color: #b60205;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Hospital/comproject/launch/list.vue